exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row-btns[data-v-5ebdfa50]{display:flex;justify-content:center;flex-wrap:wrap;gap:0.02083rem}\n", ""]);

// exports
